export default "__VITE_ASSET__DtQ7C_ct__"